function initScrollAnimations() {
  // Observamos al contenedor padre (.animated-wrapper)
  const animatedWrappers = document.querySelectorAll('.animated-wrapper');

  if (animatedWrappers.length === 0) return;

  const observer = new IntersectionObserver(
    (entries) => {
      entries.forEach((entry) => {
        const wrapper = entry.target;
        const animatedChildren = wrapper.querySelectorAll('.animated');

        if (entry.isIntersecting && entry.intersectionRatio === 1) {
          // El wrapper está completamente visible (threshold: 1),
          // activamos la animación en todos los hijos .animated
          for (const element of animatedChildren) {
            const delay = getDelayFromClass(element);
            setTimeout(() => {
              element.classList.add('show');
            }, delay);
          }
        } else {
          // El wrapper deja de estar completamente visible,
          // reseteamos las animaciones de los hijos
          for (const element of animatedChildren) {
            element.classList.remove('show');
          }
        }
      });
    },
    {
      root: null, // viewport
      rootMargin: '0px',
      threshold: 1.0, // solo cuando el wrapper esté 100% visible
    }
  );

  animatedWrappers.forEach((wrapper) => {
    observer.observe(wrapper);
  });
}

/**
 * @param {Element} element
 */
function getDelayFromClass(element) {
  const classList = element.classList;
  for (let className of classList) {
    if (className.startsWith('delay-')) {
      const delayValue = className.replace('delay-', '');
      return parseInt(delayValue) || 0;
    }
  }
  return 0;
}

//document.addEventListener('DOMContentLoaded', initScrollAnimations);
window.addEventListener('load', initScrollAnimations);